import React, { useState, useEffect } from "react";
import logo from "../../assets/images/logo.svg";
import { BrowserRouter as Router, useHistory, Link } from "react-router-dom";
import { Logout } from "../Login/Logout";
import { Tag, Space, Switch, Spin, Popconfirm, notification } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import axios from "axios";
const Activities = (props) => {
  const [loading, setLoading] = useState(false);

  const [data, setData] = useState([]);
  useEffect(() => {
    loadUsers();
  }, []);
  const loadUsers = () => {
    setLoading(true);
    const isAdmin = localStorage.getItem("isAdmin");
    if (isAdmin !== "isAdmin") {
      props.history.push("/Login");
    } else {
      axios({
        method: "GET",
        headers: { "Content-Type": "application/json" },
        url: `${process.env.REACT_APP_BASE_URL}mfb/rest/usr/usersww`,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
        withCredentials: true,
      })
        .then((res) => {
          if (res.status == 200) {
            setData(res.data);
            console.log("data", res.data);
            setLoading(false);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  const statusUser = (id, status) => {
    let url = "";
    if (status) {
      url = `${process.env.REACT_APP_BASE_URL}mfb/rest/usr/activate?id=${id}`;
    } else {
      url = `${process.env.REACT_APP_BASE_URL}mfb/rest/usr/deactivate?id=${id}`;
    }
    setLoading(true);
    axios({
      method: "POST",
      headers: { "Content-Type": "application/json" },
      url: url,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
      .then((res) => {
        if (res.status == 200) {
          setLoading(false);
          notification["success"]({
            message: "Status Changed Successfully",
          });
          loadUsers();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const deleteUser = (id) => {
    setLoading(true);
    axios({
      method: "POST",
      headers: { "Content-Type": "application/json" },
      url: `${process.env.REACT_APP_BASE_URL}mfb/rest/usr/delete?id=${id}`,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
      withCredentials: true,
    })
      .then((res) => {
        if (res.status == 200) {
          setLoading(false);
          notification["success"]({
            message: "Deleted Successfully",
          });
          loadUsers();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  return (
    <>
      <header className="navbar-header">
        <div className="home-logo">
          <img src={logo} alt="" />
          <h3>My First Book</h3>
        </div>

        <div className="home-action">
          <div className="btn-group">
            <Link to="/Register">
              <button className="btn btn-theme">Register</button>
            </Link>
            <Logout />
          </div>
        </div>
      </header>
      <div className="activities">
        <Spin tip="Loading..." spinning={loading}>
          <table className="ant-table custom-table">
            <thead className="ant-table-thead">
              <tr>
                <th className="ant-table-cell">Name</th>
                <th className="ant-table-cell">Email</th>
                <th className="ant-table-cell">Created At</th>
                <th className="ant-table-cell">Books</th>
                <th className="ant-table-cell">Role</th>
                <th className="ant-table-cell">Action</th>
              </tr>
            </thead>
            <tbody className="ant-table-tbody">
              {data &&
                data.map((val, key) => {
                  return (
                    <tr key={key} className="ant-table-row">
                      <td className="ant-table-cell">
                        {val.user.firstName
                          ? val.user.firstName + " " + val.user.lastName
                          : "Null"}
                      </td>
                      <td className="ant-table-cell">{val.user.email}</td>
                      <td className="ant-table-cell">{val.user.created}</td>
                      <td className="ant-table-cell">
                        {val.books &&
                          val.books.map((book) => {
                            return (
                              <Link to={`/Book/${book.id}`}>
                                <Tag
                                  className="cursor-pointer"
                                  color="geekblue"
                                  key={book}
                                >
                                  {book.name}
                                </Tag>
                              </Link>
                            );
                          })}
                      </td>
                      <td className="ant-table-cell">
                        {val.user.role === "Admin" ? (
                          <Tag color="green">{val.user.role}</Tag>
                        ) : (
                          <Tag color="magenta">{val.user.role}</Tag>
                        )}
                      </td>
                      <td className="ant-table-cell">
                        {val.user.role === "Normal" ? (
                          <Space size="middle">
                            <Popconfirm
                              title="Sure to delete?"
                              onConfirm={() => deleteUser(val.user.id)}
                            >
                              <DeleteOutlined className="ico-action" />
                            </Popconfirm>
                            {val.user.status === "Active" ? (
                              <Switch
                                onChange={() => statusUser(val.user.id, 0)}
                                defaultChecked
                              />
                            ) : (
                              <Switch
                                onChange={() => statusUser(val.user.id, 1)}
                              />
                            )}
                          </Space>
                        ) : (
                          "Super Admin"
                        )}
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </Spin>
      </div>
    </>
  );
};

export default Activities;
